import axios from 'axios'
import Vue from 'vue'
let axiosRCI = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    headers: {
        'Content-Type': 'application/json',
      },
  })

export async function fetchDatosRCI (context){
    try{
    let url = "rci-web/datosrci/getdatosrci"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('limit','10')
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosRCI({
        method: 'POST',
        url: url,
        data: values
    })    
    context.commit('setDatosRci',response.data.data)
    }catch(error){
        context.commit('datosrciError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function fetchDatosRCIbyVendor (context,payload){
    try{
    let url = "rci-web/datosrci/getbyvendor"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('id',payload)
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosRCI({
        method: 'POST',
        url: url,
        data: values
    })    
    context.commit('setDatosRci',response.data.data)
    }catch(error){
        context.commit('datosrciError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function fetchDatosRCIbyIngenieria (context){
    try{
    let url = "rci-web/datosrci/getbyingenieria"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('limit','10')
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosRCI({
        method: 'POST',
        url: url,
        data: values
    })    
    context.commit('setDatosRci',response.data.data)
    }catch(error){
        context.commit('datosrciError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
/**
 * Metodo que adiciona el estado Nai en la tabla.
 * @param {*} context 
 */
export async function fetchDatosRCI2 (context){
    try{
        context.commit('flushDatosRci')
        let url = "rci-web/datosrci/getdatosrci2"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('limit','10')
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosRCI({
            method: 'POST',
            url: url,
            data: values
        })    
        context.commit('setDatosRci',response.data.data)
    }catch(error){
        context.commit('datosrciError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
/**
 * Metodo que adiciona el estatus Nai a la tabla
 * @param {*} context 
 * @param {*} payload 
 */
export async function fetchDatosRCIbyVendor2 (context,payload){
    try{
        context.commit('flushDatosRci')
        let url = "rci-web/datosrci/getbyvendor2"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('id',payload)
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosRCI({
            method: 'POST',
            url: url,
            data: values
        })    
        context.commit('setDatosRci',response.data.data)
    }catch(error){
        context.commit('datosrciError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
/**
 * Metodo que agrega Estatus Nai a la tabla
 * @param {*} context 
 */
export async function fetchDatosRCIbyIngenieria2 (context){
    try{
        context.commit('flushDatosRci')
        let url = "rci-web/datosrci/getbyingenieria2"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('limit','10')
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosRCI({
            method: 'POST',
            url: url,
            data: values
        })    
        context.commit('setDatosRci',response.data.data)
    }catch(error){
        context.commit('datosrciError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}